import { OrderPayableBy, OrderPayableTo } from "../enums";

export const CUSTOMER_TO_GARAAZ_PAYABLE = {
  payableBy: OrderPayableBy.CUSTOMER,
  payableTo: OrderPayableTo.GARAAZ,
} as const;

/**
 * PaidUnpaid REGULAR/DELIVERED fetches: filter to C→G plus legacy (missing payable fields),
 * matching server outstanding semantics.
 */
export function appendPaidUnpaidRegularOrderPayableFilters(
  params: URLSearchParams,
): void {
  params.set("payableBy", CUSTOMER_TO_GARAAZ_PAYABLE.payableBy);
  params.set("payableTo", CUSTOMER_TO_GARAAZ_PAYABLE.payableTo);
  params.set("includeLegacyPayableRoutes", "true");
}
